import { InternalMetricsSummaryGrid } from './InternalMetricsSummaryGrid';

export default InternalMetricsSummaryGrid;
